import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-furnitureshop-carousel.js';

const contentHtml = `
  <div class='furnitureshop-carousel container' data-attribute='furnitureshop-carousel'>
    <div class='furnitureshop-carousel__track' data-attribute='furnitureshop-carousel__track'>
      <img
        class='furnitureshop-carousel__image'
        data-attribute='furnitureshop-carousel__image'
        src='https://cdn.skyfastimg.com/images/2026/08/21/image-6a87c9d4f511cbfea79c460e.avif?w=1000'
        alt=''
      />
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#181818',
  topPadding: true,
  bottomPadding: true,
});
